import axios from "axios";
import { API_ROUTE, headersRequest } from "../../../helpers";

export const CalendarServices = {
  getCalendarByOrganzation: async () => {
    try {
      const result = await axios.get(`${API_ROUTE}calendars`, headersRequest());
      if (result.status === 200) {
        return result.data;

      }
    } catch (error) {
      throw new Error("Error al cargar los datos");
    }
  },
  deleteCalendar: async (IdCalendar) => {
    try {
      const result = await axios.delete(`${API_ROUTE}calendar/${IdCalendar}`,headersRequest());
      if (result.status === 200) {

        console.log("calendario eliminado de la bd");
      }
    } catch (error) {
      throw new Error("error al eliminar el calendario");
    }
  },
  getOneCalendar: async (IdCalendar) => {
    try {
      const result = await axios.get(`${API_ROUTE}calendar/${IdCalendar}`,headersRequest());
      if (result.status === 200) {
        return result.data;
      }
    } catch (error) {
      throw new Error("error al traer el calendario");
    }
  },
  createCalendar: async (data) => {
    try {
      const result = await axios.post(`${API_ROUTE}calendar`,data,headersRequest());
      if (result.status === 200) {
        return result;
      }
    } catch (error) {
      throw new Error("error al crear el calendario");
    }
  },
  updateCalendar: async (data, IdCalendar) => {
    console.log(data);
    try {
      const result = await axios.put(`${API_ROUTE}calendar/${IdCalendar}`,data,headersRequest());
      if (result.status === 200) {
        return result;
      }
    } catch (error) {
      throw new Error("error al actualizar el calendario");
    }
  },
  deleteException: async (IdCalendar, IdException) => {
    try {
      const result = await axios.delete(`${API_ROUTE}exception/${IdCalendar}/${IdException}`,headersRequest());
      if (result.status === 200) {
        return result;
      }
    } catch (error) {
      throw new Error("Error al eliminar excepcion");
    }
  },
  getCalendarByProject: async(IdProject, IdCalendar)=>{
    try {
      const result = await axios.get(`${API_ROUTE}calendar/${IdProject}/${IdCalendar}`,headersRequest());
      if (result.status === 200) {

        return result.data
      }
    } catch (error) {
      throw new Error("Error al traer calendario por proyecto")
    }
  },
  getExcludeDatesDefault : async()=>{
    try {
      const result = await axios.get(`${API_ROUTE}excluded-dates`, headersRequest());
      if(result.status === 200){
        return result.data
      }
      
    } catch (error) {
      throw new Error("Error al traer las excepciones de default ")
    }
  },
  updateProjectCalendarId : async(IdProject,IdCalendar,data) => {
    try {
      const result = await axios.put(`${API_ROUTE}calendar/${IdProject}/${IdCalendar}`,data,headersRequest());
      if (result.status === 200) {
        return result;
      }
    } catch (error) {
      throw new Error("Error al actualizar el Calendario del proyecto")
    }
  } 
};
